import { getPresignedUrl } from "./getPresignedUrls";
import { UploadResponse, uploadToCdn } from "./uploadToCdn";
import imageCompression from 'browser-image-compression';

// Helper function to upload multiple files
export const uploadMultipleMedia = async (
  files: File[],
  onProgress?: (progress: number) => void
): Promise<UploadResponse[]> => {
  const uploadPromises = files.map(async (file) => {
    const isImage = file.type.startsWith('image/');

    // Get presigned URL for the file
    const { compressed, normal } = await getPresignedUrl(file);

    if (isImage) {
      const processedFile = await imageCompression(file, {
        maxSizeMB: 0.05,
        useWebWorker: true
      });

      // Upload both versions if it's an image
      const [originalUpload] = await Promise.all([
        uploadToCdn(
          file,
          normal,
          (progress: number) => {
            onProgress?.(progress / 2); // Divide progress by 2 since we're uploading two files
          }
        ),
        uploadToCdn(
          processedFile,
          compressed,
          (progress: number) => {
            onProgress?.(50 + progress / 2)
          }
        )
      ]);

      return originalUpload;
    }

    // For non-image files, just upload the original
    return uploadToCdn(
      file,
      normal,
      (progress: number) => {
        onProgress?.(progress);
      }
    );
  });

  return Promise.all(uploadPromises);
};

